// 参考代码：https://codesandbox.io/s/vue-drag-scroll-6bqzh?file=/src/App.vue:1672-2101
export default {
  inserted(el) {
    el.cursorPos = [0, 0]
    el.isDragging = true

    el.onMouseHold = (event) => {
      event.preventDefault()

      if (!el.isDragging) {
        return
      }

      // 1、标签本身滚动
      // 2、使用了 el-scrollbar 组件
      let ele = el
      if (/el-scrollbar/.test(el.className)) {
        ele = el.querySelector('.el-scrollbar__wrap')
      }

      requestAnimationFrame(() => {
        const delta = [
          event.pageX - el.cursorPos[0],
          event.pageY - el.cursorPos[1]
        ]

        el.cursorPos = [event.pageX, event.pageY]
        ele.scrollBy({
          left: -delta[0],
          top: -delta[1]
        })
      })
    }

    el.onMouseDown = (event) => {
      el.cursorPos = [event.pageX, event.pageY]
      window.addEventListener('mousemove', el.onMouseHold)
    }

    el.onMouseUp = () => {
      window.removeEventListener('mousemove', el.onMouseHold)
    }

    el.addEventListener('mousedown', el.onMouseDown)
    el.addEventListener('mouseup', el.onMouseUp)
  },
  componentUpdated(el, binding) {
    if (Object.prototype.toString.call(binding.arg) === '[object Boolean]') {
      el.isDragging = binding.arg
    }
  },
  unbind(el) {
    el.removeEventListener('mousedown', el.onMouseDown)
    el.removeEventListener('mouseup', el.onMouseUp)
  }
}
